import React from 'react';
import Modal from './Modal';

const FilterModal = ({
  data = ['model', 'make', 'vin', 'year'],
  selected,
  modal,
  onClick,
  onOutsideClick
}) => (
  <Modal
    modal={modal}
    customContentClassName="max-w-screen-md mx-auto absolute bottom-2 left-2 right-2 rounded-[7px] transition-all overflow-hidden"
    customContent={
      <div>
        <p className="text-center py-2 text-base font-semibold font-inter text-white bg-[#5046E4] border-b-1 border-[#C6C6C8]">
          Sort By
        </p>
        {data.map((item, index) => (
          <div className="" key={index} onClick={() => onClick(item)}>
            <p
              className={`font-inter text-center py-2 text-md text-[#5046E4] border-b-[0.25px] border-[#C6C6C8]${
                selected === item ? ' font-bold bg-[#5046E4]/20' : ''
              }`}>
              {item.toUpperCase()}
            </p>
          </div>
        ))}
      </div>
    }
    onOutsideClick={onOutsideClick}
  />
);

export default FilterModal;
